import { Component, Vue, Watch} from 'vue-property-decorator';
import DataTable, { TableVisibility } from '@/components/data-table/DataTable';
import { Options } from '@/components/mi-dialog/MiDialog';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import CreateDialog from '@/views/Settings/Colors/CreateDialog';
import { Color } from '@/models/Color';
import CreateSubColorDialog from '@/views/Settings/Colors/CreateSubColorDialog';
import { SubColor } from '@/models/SubColor';

@Component<Colors>({
  components: {
    CreateDialog,
    CreateSubColorDialog,
  },
})
export default class Colors extends Vue {

  protected selectedColor: Color | null = null;
  protected isCreatingColor: boolean = false;
  protected isCreatingSubColor: boolean = false;

  protected visibility: TableVisibility = {
    title: false,
    checkboxes: false,
    search: true,
  }

  protected mounted() {}

  get tableOptions(): Object {
    return {
      model: new Color().include('sub-colors').filter({only_main: true}),
      name: {
        singular: 'Color',
        plural: 'Colors',
      },
      sort: {
        key: 'name',
        order: 'ASC',
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
          sortable: {
            key: 'name',
            order: 'ASC',
          },
          width: '200px',
        },
        {
          text: 'Shortcode',
          value: 'short_name',
          width: '150px',
          sortable: {
            key: 'short_name',
            order: 'ASC',
          },
        },
        {
          text: 'Sub kleuren',
          value: 'sub_colors',
          transform: (subColors: SubColor[]) => {
            if(!subColors || !subColors.length) {
              return '-';
            }

            let string = '';
            subColors.forEach((subColor: SubColor) => {
              string += `<span class="sub-color-pill">${subColor.name}</span>`
            });

            return string;
          }
        },
      ],
      actions: [
        {
          type: 'edit',
          label: 'edit',
          icon: 'edit',
          action: (datatable: DataTable, color: Color) => {
            this.selectedColor = color;
            this.isCreatingColor = true;
          },
        },
        {
          type: 'add',
          label: 'add',
          icon: 'color_lens',
          action: (datatable: DataTable, color: Color) => {
            this.selectedColor = color;
            this.isCreatingSubColor = true;
          },
        },
        {
          type: 'delete',
          label: 'delete',
          icon: 'delete',
          action: (datatable: DataTable, color: Color) => {
            this.selectedColor = color;
            this.$store.dispatch('openDialog', this.dialogOptions);
          },
        },
      ],
      add: () => {
        this.isCreatingColor = true;
      }
    };
  }

  protected get colorsDatatable(): DataTable|null {
    const dataTable = this.$refs.colorsDatatable;
    if(dataTable) {
      return (dataTable as DataTable);
    }

    return null;
  }

  get dialogOptions(): Options {
    return {
      title: (this.selectedColor as Color).name || 'Confirm deletion',
      text: 'Are you sure you wish to delete this color?',
      type: 'warning',
      buttons: {
        confirm: {
          text: 'Delete',
          action: () => {
            if (!this.selectedColor) {
              return;
            }

            this.selectedColor
              .delete()
              .then((response: any) => {
                if (response) {
                  this.colorsDatatable ? this.colorsDatatable.refresh(true) : null;
                  this.selectedColor = null;
                }
              })
              .catch((error: AxiosError) => {
                ErrorHandler.network(error);
              });
          },
        },
        cancel: {
          text: 'Cancel',
          action: () => {
            this.selectedColor = null;
          },
        },
      },
    };
  }

  @Watch('isCreatingColor')
  protected isCreatingColorChanged() {
    if(!this.isCreatingColor) {
      this.selectedColor = null;
    }
  }
}
